import { useEntityBaseMetadata, useMessagesMetadata } from '@msdk/common'
import { EntityMetadata, FormNode, Severity } from '@msdk/definitions'

export function useHasMandatoryValidation(node: FormNode | undefined, entityName: string) {
  const baseMetadata = useEntityBaseMetadata(entityName) as EntityMetadata
  const messages = useMessagesMetadata(baseMetadata?.msProvider)
  const msgToShow = (messages || []).filter((m) => node?.value.validationMessages.includes(m.code))
  return msgToShow.some((m) => m.type === Severity.Mandatory)
}
